/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { isBoolean, isInteger, throttle } from 'lodash';
import { sizes } from '../../styles/variables.js';
import { DIMENSION } from '../../plugins/flexboxgrid/config';

/**
 * NOTE: The column offset should be handled by margin-left
 *
 * @Example `xsOffset={1} => mobile -> margin-left: 100% * 1 / 8; laptop -> margin-left: 100% * 1 / 10; desktop -> margin-left: 100% * 1 / 12 => className="ml-[12.5%] md:ml-[10%] lg:ml-[8.333333333333334%]"`
 * @Example `smOffset={2} => tablet -> margin-left: 100% * 2 / 8; laptop -> margin-left: 100% * 2 / 10; desktop -> margin-left: 100% * 2 / 12  => className="sm:ml-[25%] md:ml-[20%] lg:ml-[16.666666666666668%]"`
 */
const Col = React.forwardRef((props, ref) => {
  const { children, xs, sm, md, lg, className, reverse, ...colProps } = props;
  const [viewWidth, setViewWidth] = useState(window.document.body.clientWidth);
  const [xsCol, setXsCol] = useState();
  const [smCol, setSmCol] = useState();
  const [mdCol, setMdCol] = useState();
  const [lgCol, setLgCol] = useState();

  const reverseCssClass = useMemo(() => {
    return reverse && 'pff-flexbox-column--reverse';
  }, [reverse]);

  const isValidColValue = (colVal) => {
    return isInteger(colVal) || isBoolean(colVal);
  };

  const generateCol = (dimension, colVal) => {
    let colWidthValue = '';

    // Integer value
    if (isInteger(colVal)) {
      if (colVal === 0) {
        // Hide element
        if (dimension === DIMENSION.sm) {
          colWidthValue = 'sm:pff-flexbox-column--hidden';
        } else if (dimension === DIMENSION.md) {
          colWidthValue = 'md:pff-flexbox-column--hidden';
        } else if (dimension === DIMENSION.lg) {
          colWidthValue = 'lg:pff-flexbox-column--hidden';
        } else {
          colWidthValue = 'pff-flexbox-column--hidden';
        }
      } else {
        if (dimension === DIMENSION.sm) {
          if (colVal === 1) {
            colWidthValue = 'sm:pff-flexbox-column--1/8';
          } else if (colVal === 2) {
            colWidthValue = 'sm:pff-flexbox-column--2/8';
          } else if (colVal === 3) {
            colWidthValue = 'sm:pff-flexbox-column--3/8';
          } else if (colVal === 4) {
            colWidthValue = 'sm:pff-flexbox-column--4/8';
          } else if (colVal === 5) {
            colWidthValue = 'sm:pff-flexbox-column--5/8';
          } else if (colVal === 6) {
            colWidthValue = 'sm:pff-flexbox-column--6/8';
          } else if (colVal === 7) {
            colWidthValue = 'sm:pff-flexbox-column--7/8';
          } else if (colVal === 8) {
            colWidthValue = 'sm:pff-flexbox-column--8/8';
          }
        } else if (dimension === DIMENSION.md) {
          if (colVal === 1) {
            colWidthValue = 'md:pff-flexbox-column--1/10';
          } else if (colVal === 2) {
            colWidthValue = 'md:pff-flexbox-column--2/10';
          } else if (colVal === 3) {
            colWidthValue = 'md:pff-flexbox-column--3/10';
          } else if (colVal === 4) {
            colWidthValue = 'md:pff-flexbox-column--4/10';
          } else if (colVal === 5) {
            colWidthValue = 'md:pff-flexbox-column--5/10';
          } else if (colVal === 6) {
            colWidthValue = 'md:pff-flexbox-column--6/10';
          } else if (colVal === 7) {
            colWidthValue = 'md:pff-flexbox-column--7/10';
          } else if (colVal === 8) {
            colWidthValue = 'md:pff-flexbox-column--8/10';
          } else if (colVal === 9) {
            colWidthValue = 'md:pff-flexbox-column--9/10';
          } else if (colVal === 10) {
            colWidthValue = 'md:pff-flexbox-column--10/10';
          }
        } else if (dimension === DIMENSION.lg) {
          if (colVal === 1) {
            colWidthValue = 'lg:pff-flexbox-column--1/12';
          } else if (colVal === 2) {
            colWidthValue = 'lg:pff-flexbox-column--2/12';
          } else if (colVal === 3) {
            colWidthValue = 'lg:pff-flexbox-column--3/12';
          } else if (colVal === 4) {
            colWidthValue = 'lg:pff-flexbox-column--4/12';
          } else if (colVal === 5) {
            colWidthValue = 'lg:pff-flexbox-column--5/12';
          } else if (colVal === 6) {
            colWidthValue = 'lg:pff-flexbox-column--6/12';
          } else if (colVal === 7) {
            colWidthValue = 'lg:pff-flexbox-column--7/12';
          } else if (colVal === 8) {
            colWidthValue = 'lg:pff-flexbox-column--8/12';
          } else if (colVal === 9) {
            colWidthValue = 'lg:pff-flexbox-column--9/12';
          } else if (colVal === 10) {
            colWidthValue = 'lg:pff-flexbox-column--10/12';
          } else if (colVal === 11) {
            colWidthValue = 'lg:pff-flexbox-column--11/12';
          } else if (colVal === 12) {
            colWidthValue = 'lg:pff-flexbox-column--12/12';
          }
        } else {
          if (colVal === 1) {
            colWidthValue = 'pff-flexbox-column--1/8';
          } else if (colVal === 2) {
            colWidthValue = 'pff-flexbox-column--2/8';
          } else if (colVal === 3) {
            colWidthValue = 'pff-flexbox-column--3/8';
          } else if (colVal === 4) {
            colWidthValue = 'pff-flexbox-column--4/8';
          } else if (colVal === 5) {
            colWidthValue = 'pff-flexbox-column--5/8';
          } else if (colVal === 6) {
            colWidthValue = 'pff-flexbox-column--6/8';
          } else if (colVal === 7) {
            colWidthValue = 'pff-flexbox-column--7/8';
          } else if (colVal === 8) {
            colWidthValue = 'pff-flexbox-column--8/8';
          }
        }
      }
      // Boolean value
    } else if (colVal) {
      // Auto-width
      if (dimension === DIMENSION.sm) {
        colWidthValue = 'sm:pff-flexbox-column--show';
      } else if (dimension === DIMENSION.md) {
        colWidthValue = 'md:pff-flexbox-column--show';
      } else if (dimension === DIMENSION.lg) {
        colWidthValue = 'lg:pff-flexbox-column--show';
      } else {
        colWidthValue = 'pff-flexbox-column--show';
      }
    } else {
      // Hide element
      if (dimension === DIMENSION.sm) {
        colWidthValue = 'sm:pff-flexbox-column--hidden';
      } else if (dimension === DIMENSION.md) {
        colWidthValue = 'md:pff-flexbox-column--hidden';
      } else if (dimension === DIMENSION.lg) {
        colWidthValue = 'lg:pff-flexbox-column--hidden';
      } else {
        colWidthValue = 'pff-flexbox-column--hidden';
      }
    }

    return colWidthValue;
  };

  const handleWindowResize = () => {
    setViewWidth(window.document.body.clientWidth);
  };

  const onWindowResize = throttle(handleWindowResize, 100);

  // If window width is resized
  useEffect(() => {
    handleWindowResize();

    window.addEventListener('resize', onWindowResize);

    // Clean up listening events
    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, []);

  useEffect(() => {
    if (viewWidth < sizes.containerMinWidth.tablet) {
      if (isValidColValue(xs)) {
        setXsCol(generateCol('', xs));
      }
    }

    if (viewWidth < sizes.containerMinWidth.desktopSm) {
      if (isValidColValue(sm)) {
        setSmCol(generateCol(DIMENSION.sm, sm));
      } else if (isValidColValue(xs)) {
        setSmCol(generateCol(DIMENSION.sm, xs));
      }
    }

    if (viewWidth < sizes.containerMinWidth.desktopLg) {
      if (isValidColValue(md)) {
        setMdCol(generateCol(DIMENSION.md, md));
      } else if (isValidColValue(sm)) {
        setMdCol(generateCol(DIMENSION.md, sm));
      } else if (isValidColValue(xs)) {
        setMdCol(generateCol(DIMENSION.md, xs));
      }
    }

    if (viewWidth >= sizes.containerMinWidth.desktopLg) {
      if (isValidColValue(lg)) {
        setLgCol(generateCol(DIMENSION.lg, lg));
      } else if (isValidColValue(md)) {
        setLgCol(generateCol(DIMENSION.lg, md));
      } else if (isValidColValue(sm)) {
        setLgCol(generateCol(DIMENSION.lg, sm));
      } else if (isValidColValue(xs)) {
        setLgCol(generateCol(DIMENSION.lg, xs));
      }
    }
  }, [viewWidth, xs, sm, md, lg]);

  const cssClass = useMemo(
    () => clsx('pff-flexbox-column', reverseCssClass, xsCol, smCol, mdCol, lgCol, className),
    [reverseCssClass, xsCol, smCol, mdCol, lgCol, className],
  );

  return (
    <div {...colProps} className={cssClass} ref={ref}>
      {children}
    </div>
  );
});

Col.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  reverse: PropTypes.bool,
  xs: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  sm: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  md: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  lg: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default Col;
